module.exports = __webpack_public_path__ + "static/media/pdf.d2a2fbfc.svg";